// ATR on the chart (DWLF-446): ATR as a percent of close, and the atr.regime.* expansion /
// contraction events. One params object feeds both, so the pane always shows the series the
// markers rank. Both are computed over the FULL series and clipped to the visible window: the
// regime detector needs length + percentile-window bars of warm-up, which a short visible
// window (mobile's trailing year) would otherwise eat.
export const ATR_PARAMS = Object.freeze({ length: 14 });

const inWindow = (t, { from, to }) => (from === undefined || t >= from) && (to === undefined || t <= to);

/** ATR % of close as [{ t, v }] within the window, or null when there is nothing to draw. */
export const atrPercentSeries = (ATR, { fullCandles, from, to }) => {
  const { atrPercent } = ATR.computeAtr(fullCandles, ATR_PARAMS);
  const points = (atrPercent || [])
    .filter((point) => point && Number.isFinite(point.t) && Number.isFinite(point.v) && inWindow(point.t, { from, to }))
    .map((point) => ({ t: point.t, v: point.v }));
  return points.length ? points : null;
};

/** The jobs' atr.regime.* events (the same detector and length) within the window. */
export const atrRegimeEvents = (ATR, { fullCandles, from, to }) => (
  ATR.detectEvents(fullCandles, ATR_PARAMS).filter((event) => inWindow(event.t, { from, to }))
);

export const atrPaneTitle = () => `ATR % of close (${ATR_PARAMS.length})`;
